export const strings = {
  en: {
     "contribute_label" : "CONTRIBUTE",
     intro_line: "Stand up for Canada by supporting top quality research, polling, and campaigning. Invest in our work today.",
     step: 'Step',
     stepNames: ['Donation Amount', 'Donor Information', 'Payment Information'],
     next: "NEXT STEP",
     previous: "Previous step",
     other: "Other amount",
     optIn: "YES! Please send me occasional news, action alerts, and opportunities to support Canadian content. (You can unsubscribe at any time.)",
     add_card_label: 'Enter card number',
     footer: "131 Bloor Street West, Suite 200/238, Toronto, Ontario, M5S 1R8, Canada. Office Phone +1 866-833-1282",
     logo_url: "img/Friends-Logo.svg",
     logo_on_red_url: "img/Friends-Logo-On-Red-RGB.svg",
     logo_on_dark_url: "img/Friends-Logo-On-Dark-RGB.svg",
     donation_complete: "DONATION COMPLETE",
     thank_you: "Thank You",
     thank_you_message: "Thank you for your generous donation! You should receive a confirmation email soon.",
     is_required: 'is required',
     invalid_postal_code: 'Invalid postal code',
     single_gift: "Single gift",
     monthly_support: "Monthly support",
     submit_text: "FINISH",
     frequency: "Frequency",
     amount: "Amount",
     communications: "Communications",
     your_donation: "Your donation"
  },
  fr: {
    invalid_postal_code: "Code postal invalide",
    stepNames: ['Montant', 'Détails du donateur', 'Paiement'],
    contribute_label: "Faites un don",
    intro_line: "DÉFENDEZ NOTRE CULTURE ET NOTRE DÉMOCRATIE EN SOUTENANT NOS EFFORTS",
    step: "Étape",
    next: "Prochaine étape",
    previous: "Étape précédente",
    other: "Autre montant",
    optIn: "Oui! Je voudrais recevoir des courriels des Amis!",
    add_card_label: "Numéro de carte",
    footer: "131 Bloor Street West, Suite 200/238, Toronto, Ontario, M5S 1R8, Canada. Téléphone du bureau +1 866-833-1282",
    logo_url: "img/LesAmis-Logo.svg",
    logo_on_red_url: "img/LesAmis-Logo-On-Red.svg",
    logo_on_dark_url: "img/LesAmis-Logo-Sur-Foncé-RGB.svg",
    donation_complete: "DON COMPLÉTÉ",
    thank_you: "Merci",
    thank_you_message: "Merci pour votre don!",
    is_required: "est obligatoire",
    single_gift: "Don unique",
    monthly_support: "Don mensuel",
    submit_text: "SOUMETTRE",
    frequency: "Fréquence",
    amount: "Montant",
    communications: "Communications",
    your_donation: "Votre don"
  }
};

export const amounts = {
  single: [50, 100, 250, 500],
  monthly: [10, 15, 25, 50]
}

export const  donorFields = [
		{ placeholder: { fr: "Prénom", en: "First Name"}, required: true, name: "firstName" },
		{ placeholder: { fr: "Nom de famille", en: "Last Name"}, required: true, name: "lastName" },
		{ placeholder: { fr: "Courriel", en: "Email"}, required: true, name: "email" },
		{ placeholder: { fr: "Adresse", en: "Street Address"}, required: true, name: "address1" },
		{ placeholder: { fr: "Apt", en: "Apt/Suite"}, required: false, name: "address2" },
		{ placeholder: { fr: "Ville", en: "City"}, required: true, name: "city" },
		{ placeholder: { fr: 'Province' , en: "Province"}, required: true, name: "province" },
		{ placeholder: { fr: 'Code postale', en: "Postal Code"}, required: true, name: "postalCode" },
		{ placeholder: { fr: "Téléphone (maison)", en: "Home Phone"}, required: false, name: "homePhone" },
		{ placeholder: { fr: 'Téléphone portable', en: "Mobile Phone"}, required: false, name: "mobilePhone" }
	];
